var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mt-5 mb-3 text-muted"},[_vm._v("© 2019 Darin Mao")])}
var staticRenderFns = []

export { render, staticRenderFns }